import { useQuery } from "@tanstack/react-query";
import { getDiscountCodesConfig } from "services/discountCodes.service";
import useAuthStore from "stores/AuthStore/AuthStore";

export const DISCOUNT_CODES_CONFIG_KEY = "discount-codes-config";

/**
 * Global switch, vendor policy and community flags for the Discount codes
 * screens (contract §5.3, D-1). Cached for 30 s. Fails closed: while loading,
 * on error, or when `enabled !== true`, `enabled` is false and the screens hide.
 */
export default function useDiscountCodesConfig() {
  const { userData } = useAuthStore();
  const accountKey = userData?.vendor_id ?? userData?.account_id ?? null;

  const query = useQuery({
    queryKey: [DISCOUNT_CODES_CONFIG_KEY, accountKey],
    queryFn: async () => {
      const { data, errors } = await getDiscountCodesConfig();
      if (errors?.length) throw errors;
      return data;
    },
    enabled: Boolean(userData),
    staleTime: 30 * 1000,
    retry: false,
  });

  const config = query.isError ? null : query.data;

  return {
    enabled: config?.enabled === true,
    policy: config?.policy ?? null,
    communities: config?.communities ?? [],
    loading: query.isLoading,
    refetch: query.refetch,
  };
}
